/**
 * Define a reducer and the default state for this reducer here 'reducer.ts'
 */
/** *** */

import { produce } from "immer";
import { tLoadingAction, tLoadingState } from "./types";

export const kDefaultLoadingState = {
  global: true,
  brandFetching: false,
  companyFetching: true,
  connectionsFetching: false,
  applicationsFetching: false,
  customersFetching: false,
  draftCartFetching: false,
  messageRecipientsFetching: false,
  messagesFetching: false,
  ordersFetching: false,
  userFetching: true,
  profileUpdating: false,
  productFetching: false,
  addingProduct: false,
  profilePicUploading: false,
  sendingPaymentTerms: false,
};

type tpHandleSetLoading = (key: keyof tLoadingState, state: tLoadingState, action: tLoadingAction) => tLoadingState;
const handleSetLoading: tpHandleSetLoading = (key, state, action) => {
  state[key] = action.loading;
  return state;
};

export const LoadingReducer = produce(
  (state: tLoadingState = kDefaultLoadingState, action: tLoadingAction): tLoadingState => {
    switch (action.type) {
      case "SET_LOADING_GLOBAL":
        return handleSetLoading("global", state, action);
      case "SET_LOADING_BRAND":
        return handleSetLoading("brandFetching", state, action);
      case "SET_LOADING_COMPANY":
        return handleSetLoading("companyFetching", state, action);
      case "SET_LOADING_CONNECTIONS":
        return handleSetLoading("connectionsFetching", state, action);
      case "SET_LOADING_APPLICATIONS":
        return handleSetLoading("applicationsFetching", state, action);
      case "SET_LOADING_CUSTOMERS":
        return handleSetLoading("customersFetching", state, action);
      case "SET_LOADING_DRAFT_CART":
        return handleSetLoading("draftCartFetching", state, action);
      case "SET_LOADING_MESSAGE_RECIPIENTS":
        return handleSetLoading("messageRecipientsFetching", state, action);
      case "SET_LOADING_MESSAGES":
        return handleSetLoading("messagesFetching", state, action);
      case "SET_LOADING_ORDERS":
        return handleSetLoading("ordersFetching", state, action);
      case "SET_LOADING_USER":
        return handleSetLoading("userFetching", state, action);
      case "SET_LOADING_PRODUCT":
        return handleSetLoading("productFetching", state, action);
      case "SET_ADDING_PRODUCT":
        return handleSetLoading("addingProduct", state, action);
      case "SET_UPLOADING_PROFILE_PIC":
        return handleSetLoading("profilePicUploading", state, action);
      case "SET_UPDATING_PROFILE":
        return handleSetLoading("profileUpdating", state, action);
      case "SET_SENDING_PAYMENT_TERMS":
        return handleSetLoading("sendingPaymentTerms", state, action);
      default:
        return state;
    }
  },
);
